module.exports = __webpack_public_path__ + "img/open-quote.8feca629.svg";